import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {

  parentRouteParam !: any;
  constructor(private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, route: RouterStateSnapshot): boolean {
    // this will be passed from the route config
      this.parentRouteParam = next.parent ? next.parent.params.storename : '';

    const resetUrlToRedirect =window.location.pathname + window.location.search;
    // const a = this.jwtHelper.isTokenExpired(String(localStorage.getItem('token')));
    if (localStorage.getItem('userToken') !== 'null' && localStorage.getItem('userToken') !== 'undefined' &&
      localStorage.getItem('userToken') !== '' && localStorage.length !== 0 && localStorage.getItem('role') === 'EndUser') {
      return true;
    } else {      window.localStorage.setItem('urlToRedirect', resetUrlToRedirect);
      this.parentRouteParam ? 
      this.router.navigate(['/', this.parentRouteParam]) 
      : this.router.navigate(['/404NotFound']) ;
      return false;
    }
  }
}
